// extracted by mini-css-extract-plugin
export var content = "StickyMobileHeader-module--content--83b9c";
export var headerMobile = "StickyMobileHeader-module--headerMobile--494ac";
export var headerTop = "StickyMobileHeader-module--headerTop--dc24f";
export var home = "StickyMobileHeader-module--home--6bc65";
export var isBgFullSize = "StickyMobileHeader-module--isBgFullSize--003d1";
export var nav = "StickyMobileHeader-module--nav--fe0a6";
export var sticked = "StickyMobileHeader-module--sticked--1ed1f";
export var withBgImage = "StickyMobileHeader-module--withBgImage--922c9";
export var withPageBg = "StickyMobileHeader-module--withPageBg--73fe7";